import { useState } from 'react';
import { useEmitter } from 'hooks/useEmitter';
import clsx from 'clsx';
import styles from './llegendaAnysComparacio.module.scss';

const LlegendaAnysComparacio = (props) => {
    const { anyActual, anyAnterior, emitterId, estil, className } = props;
    const { onEmitter } = useEmitter();
    const [visible, setVisible] = useState(false);

    onEmitter(emitterId, (value) => {
        setVisible(value);
    });

    const stylesLlegenda = clsx(styles.llegendaComparacio, className, estil && styles[estil]);

    if (!visible) return <></>;

    return (
        <div className={stylesLlegenda}>
            <div className={styles.blocAny}>
                <div className={styles.any}>{anyActual}</div>
                <span className={styles.icoAnyActual}>&nbsp;</span>
            </div>
            <div className={styles.blocAny}>
                <div className={styles.any}>{anyAnterior}</div>
                <span className={styles.icoanyAnterior}>&nbsp;</span>
            </div>
        </div>
    );
};

export default LlegendaAnysComparacio;
